/* Important Info component on the BreakdownAddEditForm
   telling users where to add new locations */
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const InfoFreeze = () => {
  return (
    <div>
    <Row className="mb-3">
      <Col className="d-none d-md-block" md={1}></Col>     
      <Col xs={12} md={10} >
        <div className={`px-3 py-2 mt-2 ${styles.SubTitle6}`}>
          <p className={`${styles.Red} text-center`}>SCENE NUMBERS - UNFREEZING AND FREEZING</p>
          <hr className={`mt-2 mb-0`}/>
          <p className="pt-1">
            <span className={`${styles.Red}`}>*</span> Scene Numbers are set initially so they cannot be changed and <span className={`${styles.Red}`}>must</span> remain so 
            once Pre-production begins. 
            </p>
            <p className="pt-1">
            <span className={`${styles.Red}`}>*</span> To facilitate Scripts still in the early stages of development and
            other extreme circumstances they can be <span className={`${styles.Red}`}>temporarily unfrozen</span> using the 
            "Unfreeze Scene Numbers" button.
            </p>
            <p className="pt-1"><span className={`${styles.Red}`}>*</span> Only <span className={`${styles.Red}`}>Superadmins</span> have access to the "Unfreeze Scene Numbers" button, which when clicked 
                is replaced by the "Freeze Scene Numbers" button.
            </p>
            <p className="pt-1">
            <span className={`${styles.Red}`}>*</span> If the "Unfreeze Scene Numbers" button is clicked and Scene numbers are changed  
            work done so far may now be in the wrong Scenes.
            </p>
            <p className="pt-1"><span className={`${styles.Red}`}>*</span> <span className={`${styles.Red}`}>Ensure</span> to click the "Freeze Scene Numbers" button and lock Scene numbers down
                 once the necessary changes have been made.
            </p>
            <p className={`${styles.Red} text-center mt-5`}>DELETING SCENES</p>
          <p className="pt-1">
            <span className={`${styles.Red}`}>*</span> Scenes can be deleted by Superadmins only and should only be done 
            after <span className={`${styles.Red}`}>serious consideration </span> as 
            all Scene data and work will be irretrievably lost.
            </p>
            <hr className={`mt-2 mb-0`}/>
         </div>
      </Col>
    </Row>
    </div>
  )
}

export default InfoFreeze